import { getEncryptParams } from 'src/keycloak';
import { Builder, getHeaders, getQueryString } from './utils';
import { IS_ENCRYPTION_ENABLED } from 'src/config';
import { getPayload } from 'src/utils/encryption';
import { PERMISSION_TYPE } from 'src/types/enum';

type IGetPermissionsParams = {
  params: {
    roles?: string;
    ptype?: PERMISSION_TYPE;
    rid?: string;
  };
};

export default (builder: Builder) => {
  return {
    getPermissions: builder.query({
      async queryFn(arg: IGetPermissionsParams, _, __, fetchWithBQ) {
        const queryString = getQueryString(arg.params);
        let url = `fw/permissions${
          queryString.length ? '?' + queryString : ''
        }`;

        if (IS_ENCRYPTION_ENABLED) {
          url = `${url}${queryString.length ? '&' : '?'}payload=${btoa(
            getPayload('', getEncryptParams())
          )}`;
        }
        const response: any = await fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
        if (response.error) {
          return response;
        }
        // fw/permissions returns { data, feature_data } for user_app_perms -
        // surface both explicitly rather than relying on `data` alone, since
        // queryFn's return value is read as RTK's own {data: T} envelope and
        // any sibling key on ret_val would otherwise be silently dropped.
        if (arg.params.ptype === PERMISSION_TYPE.USER_APP_PERMISSIONS) {
          return {
            data: {
              app_perms: response.data?.data,
              feature_perms: response.data?.feature_data
            }
          };
        }
        if (arg.params.ptype === PERMISSION_TYPE.ROLE_PERMISSIONS) {
          return { data: response.data?.data };
        }
        return { data: response.data };
      },
      providesTags: ['Permissions']
    })
  };
};
